import { Component, OnInit } from '@angular/core';
import { ISession } from '../../models/session';
import { RouterLinkActive, ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { SessionsService } from '../sessions/sessions.service';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from '../../theme/theme.service';
import { filter, tap } from 'rxjs/operators';
import { has, contains, filter as rfilter, pipe, append, uniqBy } from 'ramda/es';
import * as store from 'store';
import { ThemeDirective } from '../../theme/theme.directive';
import { app_themes } from '../../theme/themes.const';

@Component({
  selector: 'app-side-menu-livee',
  templateUrl: './sidemenu-livee.component.html',
  styleUrls: ['./sidemenu-livee.component.scss']
})
export class SidemenuLiveeComponent implements OnInit {

  private links = [
    { name: 'econtent', activate: () => true, label: 'sessions.details.tabs.econtent', sessionTypes: ['eevent_main', 'eevent_child', 'simple_session'] },
    { name: 'efeatures', activate: () => true, label: 'sessions.details.tabs.efeatures', sessionTypes: ['eevent_child', 'simple_session'] },
    { name: 'eappearence', activate: () => true, label: 'sessions.details.tabs.eappearence', sessionTypes: ['eevent_main', 'simple_session'] }
  ];
  
  public logoPath = '';
  public logoAlt = '';
  public session: ISession;
  public sessionLinks: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sessionsService: SessionsService,
    private translateService: TranslateService,
    private themeService: ThemeService,

  ) { }

  ngOnInit() {
  
  
    this.router.events
    .pipe(
      filter(event => event instanceof NavigationEnd),
      tap(() => {
        if (!this.route.snapshot.firstChild) return;
        const { data, params } = this.route.snapshot.firstChild;
        this.bindTheme(data);

        // if the params object has the sessionId, so the data is a session object
        this.session = has('id', params) ? <ISession>data.data : null;
        if (this.session) {
          this.sessionLinks = rfilter((link: any) => link.sessionTypes.includes(this.session.type), this.links);
        }
      })
    )
    .subscribe(null);
  }

  bindTheme(data) {
    if (!data) return;
    if (!data.theme) data.theme = store.get(ThemeDirective.THEME);

    let newTheme: any;
    let _logoPath: any;
    let _logoAlt: any;
    if (data.theme) {
      const appTheme = app_themes[data.theme];
      if (appTheme) {
        newTheme = data.theme;
        _logoPath = appTheme[ThemeDirective.LOGO_PATH];
        _logoAlt = appTheme[ThemeDirective.LOGO_ALT];
      }
    }
    this.logoPath = _logoPath ? _logoPath : this.logoPath;
    this.logoAlt = _logoAlt ? _logoAlt : this.logoAlt;
    if (newTheme) this.themeService.setActiveTheme(newTheme);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/sidemenu-livee/sidemenu-livee.component.ts